module.exports = __webpack_public_path__ + "static/media/video.f96f36e6.gif";